// @flow
import React from 'react'
import styles from './styles'
import { Icon } from '../Icon'

type ButtonProps = {
  variant?: 'solid' | 'text',
  size?: 'default' | 'small',
  color?: 'blue' | 'gray' | 'green' | 'red',
  type?: 'button' | 'reset' | 'submit',
  label?: string,
  icon?: String,
  onClick?: () => void,
  disabled?: boolean,
}

const getSize = (size) => (size === 'default' ? styles.buttonSizeDefault : styles.buttonSizeSmall)

const getColor = (color) => {
  if (color === 'blue') {
    return styles.buttonColorBlue
  }
  if (color === 'gray') {
    return styles.buttonColorGray
  }
  if (color === 'green') {
    return styles.buttonColorGreen
  }
  if (color === 'red') {
    return styles.buttonColorRed
  }
}

const Button = (props: ButtonProps) => {
  const { variant = 'solid', size = 'default', color = 'blue', type = 'button', label, icon, onClick, disabled = false } = props

  if (variant === 'text') {
    return (
      <button type={type} className={styles.buttonText} onClick={onClick} disabled={disabled}>
        {label && label}
      </button>
    )
  }

  const disabledClass = disabled ? styles.buttonDisabled : ''

  return (
    <button type={type} className={`${getSize(size)} ${getColor(color)} ${disabledClass}`} onClick={onClick} disabled={disabled}>
      {icon && (
        <div className={styles.iconWrap}>
          <Icon icon={icon} width={20} height={20} fill="white" />
        </div>
      )}
      {label && label}
    </button>
  )
}

export default Button
